import {Button, Col, Empty, Form, Input, message, Row, Table, Tooltip} from "antd";
import {CopyOutlined, PlusOutlined} from "@ant-design/icons";
import {columnWeighingStation} from "./columns/columnWeighingStation";
import React, {useEffect, useState} from "react";
import {getAutocodeCustomer} from "../../../api/customer";
import AddWeighingStationParent from "./modal/addWeighingStationParent";
import RenderInputOnChange from "../../../common/input/RenderInputOnChange";


const Content = ({id,form, list, datasource, onDatasource,loggedIn}) => {

    const [name, setName] = useState()
    const [visible, setVisible] = useState(false)
    const copyLink = () => {

        let link = form?.getFieldValue("key") === undefined ?
            "" : form?.getFieldValue("key")
        navigator.clipboard.writeText(link);
        message.success("Đã sao chép thành công")
    }
    const copyLinkCode = () => {

        let link = form?.getFieldValue("customerCode") === undefined ?
            "" : form?.getFieldValue("customerCode")
        navigator.clipboard.writeText(link);
        message.success("Đã sao chép thành công")
    }

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (name) {
                getAutocodeCustomer(form?.getFieldValue("customerName")).then((response) => {
                    form.setFieldsValue({customerCode: response})
                })
                    .catch(() => {
                    })
            }
        }, 500)
        return () => clearTimeout(delayDebounceFn)
    }, [name, form])

    useEffect(() => {
        form.setFieldsValue({users: datasource})
    }, [])

    const phoneValidator = (_, value) => {
        if (!value) {
            return Promise.resolve();
        }

        // Regular expression for phone number validation
        const phoneRegex = /^[0-9]{10}$/;
        const phoneRegex1 = /^\+?([0-9]{2})\)?[-. ]?([0-9]{4})[-. ]?([0-9]{5})$/;

        if (!phoneRegex.test(value) && !phoneRegex1.test(value)) {
            return Promise.reject(new Error('Số điện thoại không đúng định dạng'));
        }

        return Promise.resolve();
    };

    return (
        <>
            <Row gutter={12}>
                <Col
                    xxl={{span: 24}}
                    xl={{span: 24}}
                    lg={{span: 24}}
                >
                    <RenderInputOnChange form={form}
                                         name={"customerName"}
                                         label={"Khách hàng"}
                                         placeholder={"Nhập tên khách hàng"}
                                         required={true}
                                         message={"Tên khách hàng là trường bắt buộc"}
                                         onChange={(value) => {
                                             if (id === undefined)
                                                 setName(value);
                                         }}/>
                </Col>
            </Row>

            <Row gutter={12}>
                <Col
                    xxl={{span: 24}}
                    xl={{span: 24}}
                    lg={{span: 24}}
                >
                    <Form.Item
                        label={"Mã khách hàng"}
                        name="customerCode"
                    >
                        <Input disabled={true}
                               addonAfter={<>
                                   <Tooltip title="Sao chép mã khách hàng">
                                       <CopyOutlined onClick={copyLinkCode} style={{color: "black"}}/>
                                   </Tooltip>
                               </>}
                        />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={12}>
                <Col
                    xxl={{span: 24}}
                    xl={{span: 24}}
                    lg={{span: 24}}
                >
                    <Form.Item
                        label={"Key"}
                        name="key"
                    >
                        <Input disabled={true}
                               addonAfter={<>
                                   <Tooltip title="Sao chép key">
                                       <CopyOutlined onClick={copyLink} style={{color: "black"}}/>
                                   </Tooltip>
                               </>}
                        />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={12}>
                <Col
                    xxl={{span: 24}}
                    xl={{span: 24}}
                    lg={{span: 24}}
                >
                    <Form.Item
                        label={"Email"}
                        name="email"
                        rules={[
                            {
                                required: true,
                                message: "Email là trường bắt buộc"
                            },
                            {
                                type: 'email',
                                message: "Email không đúng định dạng"
                            }
                        ]}
                        normalize={(value, prevVal, prevVals) => value.trim()}
                    >
                        <Input placeholder={"Nhập Email"} disabled={loggedIn}/>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={12}>
                <Col
                    xxl={{span: 24}}
                    xl={{span: 24}}
                    lg={{span: 24}}
                >
                    <Form.Item
                        label={"Số điện thoại"}
                        name="phoneNumber"
                        rules={[
                            { validator: phoneValidator },
                        ]}
                        normalize={(value, prevVal, prevVals) => value.trim()}
                    >
                        <Input placeholder={"Nhập số điện thoại"}/>
                    </Form.Item>
                </Col>
            </Row>

            {
                list && <Row gutter={12}>
                    <Col
                        xxl={{span: 24}}
                        xl={{span: 24}}
                        lg={{span: 24}}
                    >
                        <Form.Item
                            noStyle={true}
                        >
                            <Table columns={columnWeighingStation}
                                   dataSource={datasource}
                                   pagination={false}
                                   locale={{
                                       emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                         description={
                                           <>
                                               Khách hàng chưa có trạm cân nào
                                               <span style={{color: "#1890FF"}}> bấm vào đây </span>
                                               để thêm mới trạm cân
                                           </>
                                       }  onClick={() => setVisible(true)} className={"cursor-pointer"} />
                                   }}/>
                        </Form.Item>
                        {
                            id && <Button
                                onClick={() => setVisible(true)}
                                type="link"
                                icon={<PlusOutlined/>}
                                style={{color: "#1890FF"}}
                            >
                                Thêm trạm cân
                            </Button>
                        }

                    </Col>
                </Row>
            }

            <AddWeighingStationParent visible={visible}
                                      onCancel={() => setVisible(false)}
                                      onDatasource={onDatasource}/>

        </>
    )
}

export default Content
